export const SENSITIVE_MAP = { low: '低', medium: '中', high: '高' }

export const DEFAULT_MODULE_HINT = {
    message: '勾选模块即把模块下已公开的接口授权给这个应用',
    description: '使用者能看到多少数据，由他在各业务系统里的权限决定，这里不配置数据范围。模块下的接口如果还没设为公开，需要在接口管理页先设为公开才会授权。',
}

/** 按业务域分组展示模块；停用的模块不能再关联，直接不展示。 */
export function toModuleDomains(catalog) {
    const grouped = {}
    const modules = Array.isArray(catalog) ? catalog : (catalog?.list || [])
    modules
        .filter((module) => module && module.status !== 'disabled')
        .forEach((module) => {
            const domainName = module.domainName || '未设置业务域'
            if (!grouped[domainName]) grouped[domainName] = []
            grouped[domainName].push(module)
        })
    return Object.keys(grouped).map((domainName) => ({ domainName, modules: grouped[domainName] }))
}

/** 已选模块的接口统计与敏感模块清单，用于保存前的确认提示。 */
export function summarizeSelection(catalog, selectedCodes) {
    const codes = Array.isArray(selectedCodes) ? selectedCodes : []
    const modules = Array.isArray(catalog) ? catalog : (catalog?.list || [])
    const selected = modules.filter((module) => codes.includes(module?.moduleCode))
    return {
        selected,
        sensitive: selected.filter((module) => module.sensitiveLevel && module.sensitiveLevel !== 'low'),
        publicCount: selected.reduce((sum, module) => sum + (module.publicApiCount || 0), 0),
        totalCount: selected.reduce((sum, module) => sum + (module.apiCount || 0), 0),
    }
}

export function buildModuleSaveMessage(result) {
    const parts = [`保存成功，将开放 ${result?.grantedApiCount || 0} 个接口`]
    if (result?.notPublicApiCodes?.length) {
        parts.push(`${result.notPublicApiCodes.length} 个接口未公开，暂不授权`)
    }
    if (result?.unavailableApiCodes?.length) {
        parts.push(`${result.unavailableApiCodes.length} 个接口已停用`)
    }
    if (result?.rejectedModules?.length) {
        parts.push(`${result.rejectedModules.length} 个模块未生效`)
    }
    return parts.join('；')
}
